import axios from 'axios'

/**
 * Status pendaftaran browser ini sebagai device POS (`pos_device`). BE mengembalikannya
 * lewat /inits + device_id (kontrak yang sama dengan kledopos-mobile). Di web hanya
 * dipanggil dari kasir setelah outlet dipilih — login & /inits global tidak membawa
 * device_id supaya modul lain (finance) tidak terdampak.
 */
export const getPosDeviceStatus = (deviceId, config = {}) => {
  return axios.get('/inits', { ...config, params: { v: '1', device_id: deviceId } })
}

/**
 * Daftarkan browser ini sebagai device POS (sama dengan kledopos-mobile).
 * `device_info` opsional (model/OS/browser), tidak dikirim bila kosong.
 */
export const registerPosDevice = ({ device_id, nickname, device_info }, config = {}) => {
  return axios.put('/pos/devices', { device_id, nickname, device_info }, config)
}
